import classNames from 'classnames';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import { Container } from 'components/Grid';
import RichText from 'components/RichText';
import { largeUp, medium, mediumUp } from 'constants/mediaQueries';
import CollectionBreadcrumbs from 'containers/CollectionBreadcrumbsContainer';
import CollectionDeadEnd from 'containers/CollectionDeadEndContainer';
import CollectionFilterDrawer from 'containers/CollectionFilterDrawerContainer';
import CollectionFilterPane from 'containers/CollectionFilterPaneContainer';
import CollectionFilterToggle from 'containers/CollectionFilterToggleContainer';
import CollectionsCarouselRecsContainer from 'containers/CollectionsCarouselRecsContainer';
import CollectionSecondaryNavigation from 'containers/CollectionSecondaryNavigationContainer';
import Faq from 'containers/FaqContainer';
import PillToggle from 'containers/PillToggleContainer';
import Theme from 'styles/theme';

const MobileLayout = ({
  children,
  descriptionModule,
  faq,
  hasSecondaryNavigationOptions,
  promotedNavExperimentData,
  showFilterToggle,
  showPillToggle,
  leftPillToggle,
  rightPillToggle,
  stickyFilterCampaignData,
  stickyFilterCampaignEngagementIdentifiers,
}) => {
  return (
    <div className={classNames('MobileLayout', { 'MobileLayout--toggle-enabled': showPillToggle })}>
      {isEmpty(stickyFilterCampaignData) && (
        <div className="MobileLayout__banner">
          <div className="MobileLayout__breadcrumbs" id="collection-page-breadcrumbs" tabIndex="-1">
            <CollectionBreadcrumbs />
            {showFilterToggle && !showPillToggle && <CollectionFilterToggle />}
          </div>
          {hasSecondaryNavigationOptions && isEmpty(promotedNavExperimentData) && (
            <div className="MobileLayout__secondary-navigation">
              <CollectionSecondaryNavigation />
            </div>
          )}
          {showPillToggle && (
            <div className="MobileLayout__toggle-container">
              <PillToggle leftPillToggle={leftPillToggle} rightPillToggle={rightPillToggle} />
              {showFilterToggle && <CollectionFilterToggle />}
            </div>
          )}
        </div>
      )}

      {/* 
          For the sticky filter experiment, we have two different variations where we include the secondary nav or not
          and we also have two different layouts for the unisex toggle
          TODO: Clean this after the experiment is over
       */}

      {!isEmpty(stickyFilterCampaignData) &&
        !stickyFilterCampaignData?.includeSubcategories &&
        showPillToggle && (
          <>
            <div
              className="MobileLayout__breadcrumbs"
              id="collection-page-breadcrumbs"
              tabIndex="-1"
            >
              <CollectionBreadcrumbs />
            </div>

            {hasSecondaryNavigationOptions && isEmpty(promotedNavExperimentData) && (
              <div className="MobileLayout__secondary-navigation">
                <CollectionSecondaryNavigation />
              </div>
            )}

            <div className="MobileLayout__sticky">
              <div className="MobileLayout__toggle-container">
                <PillToggle
                  rightPillToggle={rightPillToggle}
                  leftPillToggle={leftPillToggle}
                  experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                />
                {showFilterToggle && (
                  <CollectionFilterToggle
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                )}
              </div>
            </div>
          </>
        )}

      {!isEmpty(stickyFilterCampaignData) &&
        stickyFilterCampaignData?.includeSubcategories &&
        showPillToggle && (
          <>
            <div
              className="MobileLayout__breadcrumbs"
              id="collection-page-breadcrumbs"
              tabIndex="-1"
            >
              <CollectionBreadcrumbs />
            </div>

            <div className="MobileLayout__sticky">
              {hasSecondaryNavigationOptions && isEmpty(promotedNavExperimentData) && (
                <div className="MobileLayout__secondary-navigation">
                  <CollectionSecondaryNavigation
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                </div>
              )}

              <div className="MobileLayout__toggle-container">
                <PillToggle
                  rightPillToggle={rightPillToggle}
                  leftPillToggle={leftPillToggle}
                  experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                />
                {showFilterToggle && (
                  <CollectionFilterToggle
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                )}
              </div>
            </div>
          </>
        )}

      {!isEmpty(stickyFilterCampaignData) &&
        stickyFilterCampaignData?.includeSubcategories &&
        !showPillToggle && (
          <>
            <div className="MobileLayout__sticky">
              <div
                className="MobileLayout__breadcrumbs"
                id="collection-page-breadcrumbs"
                tabIndex="-1"
              >
                <CollectionBreadcrumbs />
                {showFilterToggle && (
                  <CollectionFilterToggle
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                )}
              </div>

              {hasSecondaryNavigationOptions && isEmpty(promotedNavExperimentData) && (
                <div className="MobileLayout__secondary-navigation">
                  <CollectionSecondaryNavigation
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                </div>
              )}
            </div>
          </>
        )}

      {!isEmpty(stickyFilterCampaignData) &&
        !stickyFilterCampaignData?.includeSubcategories &&
        !showPillToggle && (
          <>
            <div className="MobileLayout__sticky">
              <div
                className="MobileLayout__breadcrumbs"
                id="collection-page-breadcrumbs"
                tabIndex="-1"
              >
                <CollectionBreadcrumbs />
                {showFilterToggle && (
                  <CollectionFilterToggle
                    experimentEngagementIds={stickyFilterCampaignEngagementIdentifiers}
                  />
                )}
              </div>
            </div>

            {hasSecondaryNavigationOptions && isEmpty(promotedNavExperimentData) && (
              <div className="MobileLayout__secondary-navigation">
                <CollectionSecondaryNavigation />
              </div>
            )}
          </>
        )}

      <div className="MobileLayout__results">{children}</div>

      <CollectionsCarouselRecsContainer />

      {hasSecondaryNavigationOptions && (
        <div className="MobileLayout__dead-end">
          <CollectionDeadEnd />
        </div>
      )}
      {descriptionModule && (
        <Container className="MobileLayout__description-module-container">
          <RichText content={descriptionModule} />
        </Container>
      )}

      <div className="MobileLayout__faq">
        <Faq {...faq} />
      </div>

      <CollectionFilterDrawer>
        <div className="MobileLayout__filter-pane">
          <CollectionFilterPane />
        </div>
      </CollectionFilterDrawer>
      <style jsx>
        {`
          .MobileLayout {
            padding: 0;
          }

          .MobileLayout__toggle-container {
            display: flex;
            justify-content: space-between;
            margin: ${Theme.get('spacing') * 1.5}px ${Theme.get('spacing') * 5}px 0px
              ${Theme.get('spacing') * 5 - 2}px;
            padding-top: ${Theme.get('spacing')}px;
          }

          .MobileLayout__breadcrumbs {
            display: flex;
            justify-content: space-between;
            outline: none;
            padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 3}px
              ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 5}px;
          }

          .MobileLayout__filter-pane {
            margin: ${Theme.get('spacing') * 4}px 0 ${Theme.get('spacing') * 4}px
              ${Theme.get('spacing') * 4}px;
          }

          .MobileLayout__sticky {
            position: sticky;
            top: ${Theme.get('top-navigation-height-px')};
            z-index: ${Theme.get('z-index-collection-sticky-nav')};
            background-color: ${Theme.get('colors-white')};
            padding-bottom: ${showPillToggle ? Theme.get('spacing') : 0}px;
          }

          @media ${mediumUp} {
            .MobileLayout__filters {
              padding-left: ${Theme.get('spacing') * 3}px;
              padding-right: ${Theme.get('spacing') * 3}px;
            }

            .MobileLayout__breadcrumbs {
              margin: ${Theme.get('spacing') * 3}px 0;
              padding: 0 ${Theme.get('spacing') * 5}px;
            }

            .MobileLayout__toggle-container {
              margin: ${Theme.get('spacing') * 2.5}px 0 0 0;
              padding: 0 ${Theme.get('spacing') * 5}px;
            }
          }

          @media ${largeUp} {
            .MobileLayout__breadcrumbs {
              margin: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 7}px
                ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 8}px;
              padding: ${Theme.get('spacing') * 3}px ${Theme.get('spacing') * 3}px
                ${Theme.get('spacing') * 2}px ${Theme.get('spacing') * 5}px;
            }

            .MobileLayout__toggle-container {
              margin: ${Theme.get('spacing') * 2.5}px ${Theme.get('spacing') * 8}px 0px
                ${Theme.get('spacing') * 7.5}px;
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .MobileLayout .CollectionFilters__overview--mobile {
            padding-left: ${Theme.get('spacing') * 5}px;
            padding-right: ${Theme.get('spacing') * 5}px;
          }

          .MobileLayout--toggle-enabled div.CollectionPromotedNavigation__container {
            border-top: none;
            padding-top: 19px;
          }

          .MobileLayout__description-module-container.Container {
            padding-top: ${Theme.get('spacing') * 5}px;
          }

          .MobileLayout__description-module-container.Container .typography--secondary-heading {
            margin-bottom: ${Theme.get('spacing') * 2}px;
            font-size: ${Theme.get('font-size-large-px')};
          }

          .MobileLayout__description-module-container.Container .Paragraph {
            font-size: ${Theme.get('font-size-description-px')};
          }

          @media ${medium} {
            .MobileLayout__description-module-container.Container .typography--secondary-heading {
              font-size: 22px; // Match FAQ's tertiary heading
            }
          }
        `}
      </style>
    </div>
  );
};

MobileLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  hasSecondaryNavigationOptions: PropTypes.bool,
  showFilterToggle: PropTypes.bool,
  showPillToggle: PropTypes.bool,
  leftPillToggle: PropTypes.shape({}),
  rightPillToggle: PropTypes.shape({}),
  promotedNavExperimentData: PropTypes.shape({}),
  faq: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        fields: PropTypes.shape({}),
      })
    ),
  }),
  stickyFilterCampaignData: PropTypes.shape({
    includeSubcategories: PropTypes.bool,
  }),
  stickyFilterCampaignEngagementIdentifiers: PropTypes.shape({
    dyDecisionId: PropTypes.string,
    dyVariationId: PropTypes.number,
  }),
  descriptionModule: PropTypes.shape({}),
};

MobileLayout.defaultProps = {
  children: null,
  showFilterToggle: true,
  showPillToggle: false,
  leftPillToggle: null,
  rightPillToggle: null,
  hasSecondaryNavigationOptions: false,
  faq: null,
  stickyFilterCampaignData: {},
  stickyFilterCampaignEngagementIdentifiers: {},
  descriptionModule: null,
};

export default MobileLayout;
